import { trackEvent } from '@domain/analytics/trackEvent';
import { trackNavigationBetweenWaters } from '@domain/analytics/trackNavigationBetweenWaters';
import { logger } from '@lib/logger/logger';
import { HandleMapIconClick } from '../types/types';

import { checkAndReturnCatchIconData } from './mapHelpers';

export const handleCatchIconClick: HandleMapIconClick = ({
  layerId,
  event,
  map,
  setSelectedIcon,
}) => {
  logger.debug('Catch icon click');

  const latitude = event.lngLat.lat;
  const longitude = event.lngLat.lng;

  const features = map.queryRenderedFeatures(event.point, {
    layers: [layerId],
  });

  if (features.length < 1) {
    throw new Error(
      `No Id was found when clicking that icon - Lat: ${latitude}, Lng: ${longitude}`,
    );
  }

  const catchId = checkAndReturnCatchIconData(features, longitude, latitude);

  trackNavigationBetweenWaters('map');
  trackEvent({
    name: 'mykiss_explore_marker_clicked',
    properties: {
      type: 'catch',
    },
  });

  setSelectedIcon({
    drawerViewId: catchId,
    drawerView: 'catch',
    latitude,
    longitude,
  });
};
